<div>
  @for (avatar of avatars; track avatar; let i = $index) {
    <se-fe-avatar
      class="avatar-group"
      [ngStyle]="{ 'margin-left': i > 0 ? '-10px' : 0, 'z-index': avatars.length - i }"
      (click)="goToHousehold(avatar.id)"
      seFeDataType="persona"
      [seFeDataIdentity]="avatar.title"
      [seFeDataImgUrl]="avatar.imageUrl"
      seFeDataSize="200">
    </se-fe-avatar>
  }
</div>
